export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-v1-960-5c82e879b074ff3dbc570b150d1e0f1f.webp";